import React, { useEffect, useState } from "react";
import OTPInput from "react-otp-input";
import styles from "./OTP.module.css";
import { removeCountryCode } from "@/utils/cookieutils";
import axios from "axios";
import { toast } from "react-hot-toast";
import { trackEventPreEnrolment } from "@/services/mixpanel";

const OTP = ({
  mobileNumber,
  countryCode,
  setStep,
  // onClose,
  handlesendOTP,
  resendDisabled,
  onOtpSuccess,
}: any) => {
  const [otp, setOtp] = useState("");
  const [timeLeft, setTimeLeft] = useState(30);
  const [showResendButton, setShowResendButton] = useState(false);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const mobileWithoutCode = removeCountryCode(countryCode, mobileNumber);
  const BASE_URL = process.env.UNIFIED_RMS_BASE_URL;

  useEffect(() => {
    if (timeLeft === 0) {
      setShowResendButton(true);
      return;
    }

    const timer = setInterval(() => {
      setTimeLeft((prevTime) => prevTime - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [timeLeft]);

  const handleOtpChange = (value: any) => {
    setOtp(value.replace(/[^0-9]/g, ""));
    setError("");
  };

  // const handleLoadingClose = () => {
  //   setIsLoadingOpen(false);
  // };

  const handleKeyPress = (e: any) => {
    if (!/[0-9]/.test(e.key)) {
      e.preventDefault();
    }
  };

  const handlePaste = (e: any) => {
    const pastedValue = e.clipboardData.getData("Text");
    const numericValue = pastedValue.replace(/[^0-9]/g, "");
    setOtp(numericValue);
    e.preventDefault();
  };

  const handleChangePhoneNumber = () => {
    setStep(3);
    if (mobileNumber)
      trackEventPreEnrolment("change_phone_number_clicked", {
        phone_number: mobileNumber,
      });
  };

  const handleOtpSubmit = async () => {
    if (!otp || otp.length !== 4 || !/^\d+$/.test(otp)) {
      toast.error("Invalid OTP. Please enter a valid OTP");
      setOtp("");
      return;
    }
    const payload = {
      mobileNumber: mobileWithoutCode,
      mobileCountryCode: countryCode,
      otp: Number(otp),
    };

    if (payload) {
      try {
        setIsLoading(true);
        const response = await axios.post(
          `${BASE_URL}auth/login-verify`,
          payload
        );
        if (response?.data?.statusCode === 200) {
          toast.success("OTP Verified Successfully 🎉");
          onOtpSuccess(
            response?.data?.data?.tokenDetails,
            response?.data?.data?.status, 
            response?.data?.data?.studentCode
          );
        }
      } catch (error) {
        toast.error("Please enter a valid OTP");
        setOtp("");
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handleResendOTP = () => {
    setTimeLeft(30);
    setShowResendButton(false);
    setError("");
    setOtp("");
    handlesendOTP();
  };

  return (
    <>
      <div className={styles.toptextContainer}>
        <h2 className={styles.otpHeader}>OTP Verification</h2>
      </div>
      <div className={styles.otpInputContainer}>
        <div className={styles.topText}>
          Enter the 4-digit OTP sent to your number +{countryCode}
          {mobileWithoutCode}.
        </div>
        <OTPInput
          value={otp}
          onChange={handleOtpChange}
          numInputs={4}
          shouldAutoFocus
          renderInput={(props: any) => (
            <input
              {...props}
              className={styles.otpInput}
              onKeyPress={handleKeyPress}
              onPaste={handlePaste}
            />
          )}
          containerStyle={styles.otpContainer}
        />
        {error && <p className={styles.otpErrorMessage}>{error}</p>}

        <div>
          {!resendDisabled && (
            <div className={styles.resend}>
              {showResendButton ? (
                <button
                  onClick={handleResendOTP}
                  className={styles.resendPhone}
                >
                  Resend Code
                </button>
              ) : (
                <p className={styles.otpTime}>Resend OTP in {timeLeft} sec</p>
              )}
            </div>
          )}
        </div>
      </div>

      <hr className={styles.bottomHr} />

      <div className="d-flex align-items-center justify-content-center mt-3">
        <button
          className={`${styles.otpVerifyButton} ${
            isLoading ? styles.disabled : ""
          }`}
          onClick={handleOtpSubmit}
          disabled={isLoading}
        >
          {isLoading ? "Verifying..." : "Verify and Proceed"}
        </button>
      </div>
      <span className={styles.changePhone} onClick={handleChangePhoneNumber}>
        Change Phone Number
      </span>

      {/* <Loading
        isOpen={isLoadingOpen}
        onClose={handleLoadingClose}
        userStatus={userStatus}
        tokenDetails={tokenDetails}
      /> */}
    </>
  );
};

export default OTP;
